export const AppointmentModal = {
  show: (el, s) => s.root.showAppointmentModal,
  position: 'fixed',
  top: '0',
  left: '0',
  width: '100%',
  height: '100%',
  zIndex: '1000',

  Backdrop: {
    position: 'absolute',
    top: '0', left: '0', width: '100%', height: '100%',
    background: 'black.5',
    cursor: 'pointer',
    onClick: (e, el, s) => s.root.update({ showAppointmentModal: false })
  },

  ModalPanel: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    attr: { style: 'transform: translate(-50%, -50%)' },
    width: '90%',
    maxWidth: 'H',
    background: 'inkMid',
    round: 'B',
    boxShadow: '0 B D black.2',
    flow: 'y',
    overflow: 'hidden',

    ModalHeader: {
      flow: 'x',
      align: 'center space-between',
      padding: 'A B',
      borderBottom: '1px solid inkBorder',
      HeaderTitle: { text: '{{ appointmentDetails | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText' },
      CloseBtn: {
        tag: 'button',
        text: '\u2715',
        background: 'transparent',
        border: 'none',
        fontSize: 'A',
        color: 'inkMuted',
        cursor: 'pointer',
        padding: 'Y',
        round: 'Y',
        ':hover': { background: 'inkSurface' },
        onClick: (e, el, s) => s.root.update({ showAppointmentModal: false })
      }
    },

    ModalBody: {
      flow: 'y',
      gap: 'A',
      padding: 'B',

      ApptTime: {
        flow: 'x', gap: 'Z', align: 'center flex-start',
        TimeIcon: { extends: 'Icon', icon: 'clock', width: 'A', height: 'A', color: 'teal' },
        TimeValue: { text: (el, s) => (s.root.selectedAppointment || {}).time || '', fontSize: 'B', fontWeight: '700', color: 'teal' }
      },

      ApptPatient: {
        flow: 'x', gap: 'Z', align: 'center flex-start',
        PatientIcon: { extends: 'Icon', icon: 'users', width: 'A', height: 'A', color: 'inkMuted' },
        PatientInfo: {
          flow: 'y', gap: 'W',
          PatientLabel: { text: '{{ patient | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
          PatientName: {
            extends: 'Link',
            href: '/patient',
            text: (el, s) => (s.root.selectedAppointment || {}).patient || '',
            fontSize: 'A',
            fontWeight: '600',
            color: 'teal',
            textDecoration: 'none',
            ':hover': { textDecoration: 'underline' }
          }
        }
      },

      ApptService: {
        flow: 'x', gap: 'Z', align: 'center flex-start',
        ServiceIcon: { extends: 'Icon', icon: 'tooth', width: 'A', height: 'A', color: 'inkMuted' },
        ServiceInfo: {
          flow: 'y', gap: 'W',
          ServiceLabel: { text: '{{ service | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
          ServiceValue: { text: (el, s) => (s.root.selectedAppointment || {}).service || '', fontSize: 'A', fontWeight: '500', color: 'inkText' }
        }
      },

      ApptDoctor: {
        flow: 'x', gap: 'Z', align: 'center flex-start',
        DoctorIcon: { extends: 'Icon', icon: 'stethoscope', width: 'A', height: 'A', color: 'inkMuted' },
        DoctorInfo: {
          flow: 'y', gap: 'W',
          DoctorLabel: { text: '{{ doctor | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
          DoctorValue: { text: (el, s) => (s.root.selectedAppointment || {}).doctor || '', fontSize: 'A', fontWeight: '500', color: 'inkText' }
        }
      },

      ApptStatus: {
        flow: 'x', gap: 'Z', align: 'center flex-start',
        StatusIcon: { extends: 'Icon', icon: 'check', width: 'A', height: 'A', color: 'inkMuted' },
        StatusInfo: {
          flow: 'y', gap: 'W',
          StatusLabel: { text: '{{ status2 | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
          StatusBadgeWrap: { extends: 'StatusBadge', state: (el, s) => ({ status: (s.root.selectedAppointment || {}).status || 'Pending' }) }
        }
      }
    },

    ModalFooter: {
      flow: 'x',
      gap: 'Z',
      padding: 'A B',
      borderTop: '1px solid inkBorder',
      align: 'center flex-end',

      OpenPatientBtn: {
        extends: 'Link',
        href: '/patient',
        text: '{{ openPatientRecord | polyglot }}',
        background: 'teal',
        color: 'ink',
        fontWeight: '600',
        padding: 'Z A',
        round: 'A',
        fontSize: 'Z',
        textDecoration: 'none',
        cursor: 'pointer'
      },
      CancelApptBtn: {
        extends: 'Button',
        text: '{{ cancel | polyglot }}',
        background: 'inkSurface',
        color: 'inkText',
        fontWeight: '600',
        padding: 'Z A',
        round: 'A',
        fontSize: 'Z',
        cursor: 'pointer',
        border: '1px solid inkBorder',
        onClick: (e, el, s) => s.root.update({ showAppointmentModal: false })
      }
    }
  }
}
